import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import Button from 'components/uiKit/Button'
import { isMixed } from 'components/uiKit/KitUtils'
import { useOpenModal } from 'components/uiKit/Modal'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'

import type { ICodeEditorProps } from '../CodeEditor/CodeEditor'
import CodeEditorModal from '../CodeEditorModal'

const FieldCodeEditor = ({
  name,
  onChange,
  value,
  defaultValue: _defaultValue,
  ...rest
}: AdapterKitControlProps<ICodeEditorProps, string>) => {
  const modal = useOpenModal(CodeEditorModal, {})
  const handleChange = useCallback((value: string) => onChange({ name, value }), [name, onChange])
  const safeValue = isMixed(value) ? undefined : (value as string | undefined)
  const handleClick = useCallback(() => {
    modal.open({
      name: 'CodeEditorModal',
      onChange: handleChange,
      ...rest,
      value: safeValue,
    })
  }, [modal, handleChange, rest, safeValue])

  return (
    <div>
      <Typography indents={{ marginBottom: 24, marginTop: 8 }} styleType='hint'>
        {t('elements.embedded.form.htmlHint')}
      </Typography>
      <Button name='OpenCodeEditor' onClick={handleClick} fluid>
        {t('elements.embedded.form.openEditor')}
      </Button>
    </div>
  )
}

export default React.memo(FieldCodeEditor) as typeof FieldCodeEditor
